document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.compose-box').forEach((box) => {
    const formatButtons = box.querySelectorAll('[data-compose-format]');
    const flavorRows = box.querySelectorAll('[data-compose-flavor]');
    const countEl = box.querySelector('[data-compose-count]');
    const limitEl = box.querySelector('[data-compose-limit]');
    const addButton = box.querySelector('[data-compose-add]');

    if (
      !formatButtons.length ||
      !flavorRows.length ||
      !countEl ||
      !limitEl ||
      !addButton
    ) {
      return;
    }

    let currentLimit = 0;
    let currentCount = 0;
    let selectedFormatVariantId = null;
    let isSubmitting = false;

    const getFlavorQuantity = (row) => {
      const quantityEl = row.querySelector('[data-compose-quantity]');
      return Number(quantityEl?.textContent || 0);
    };

    const setFlavorQuantity = (row, quantity) => {
      const quantityEl = row.querySelector('[data-compose-quantity]');
      const minusButton = row.querySelector('[data-compose-minus]');

      if (!quantityEl) return;

      quantityEl.textContent = String(quantity);

      if (minusButton) {
        minusButton.disabled = quantity <= 0;
      }
    };

    const resetFlavors = () => {
      flavorRows.forEach((row) => {
        setFlavorQuantity(row, 0);
      });

      currentCount = 0;
    };

    const updateInterface = () => {
      countEl.textContent = String(currentCount);
      limitEl.textContent = String(currentLimit);

      const isComplete =
        currentLimit > 0 &&
        currentCount === currentLimit;

      addButton.disabled = !isComplete || isSubmitting;

      flavorRows.forEach((row) => {
        const plusButton = row.querySelector('[data-compose-plus]');
        const available = row.dataset.available === 'true';

        if (plusButton) {
          plusButton.disabled =
            !available ||
            currentLimit === 0 ||
            currentCount >= currentLimit ||
            isSubmitting;
        }
      });

      addButton.textContent = isComplete
        ? addButton.dataset.labelAdd
        : addButton.dataset.labelComplete;
    };

    const selectFormat = (button) => {
      formatButtons.forEach((formatButton) => {
        const selected = formatButton === button;

        formatButton.classList.toggle('is-selected', selected);
        formatButton.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });

      currentLimit = Number(button.dataset.size || 0);
      selectedFormatVariantId = button.dataset.variantId;

      resetFlavors();
      updateInterface();
    };

    formatButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (isSubmitting) return;
        selectFormat(button);
      });
    });

    flavorRows.forEach((row) => {
      const plusButton = row.querySelector('[data-compose-plus]');
      const minusButton = row.querySelector('[data-compose-minus]');

      plusButton?.addEventListener('click', () => {
        if (currentCount >= currentLimit || isSubmitting) return;

        const currentQuantity = getFlavorQuantity(row);

        setFlavorQuantity(row, currentQuantity + 1);
        currentCount += 1;

        updateInterface();
      });

      minusButton?.addEventListener('click', () => {
        if (isSubmitting) return;

        const currentQuantity = getFlavorQuantity(row);

        if (currentQuantity <= 0) return;

        setFlavorQuantity(row, currentQuantity - 1);
        currentCount -= 1;

        updateInterface();
      });
    });

    

    addButton.addEventListener('click', async () => {
        if (
            isSubmitting ||
            currentLimit === 0 ||
            currentCount !== currentLimit
        ) {
            return;
        }

        const boxId = `wellioo-box-${Date.now()}`;

        const items = [];

        flavorRows.forEach((row) => {
            const quantity = getFlavorQuantity(row);
            const variantId = Number(row.dataset.variantId);

            if (quantity > 0 && variantId) {
            items.push({
                id: variantId,
                quantity,
                properties: {
                _compose_box_id: boxId,
                _compose_box_size: String(currentLimit),
                _compose_format_variant_id: String(selectedFormatVariantId)
                }
            });
            }
        });

        if (!items.length) return;

        try {
            isSubmitting = true;
            updateInterface();

            /*
            * Ask Shopify to return the same cart sections
            * used by the theme's native cart components.
            */
            const sectionIds = [];

            document
            .querySelectorAll('cart-items-component')
            .forEach((component) => {
                if (
                component instanceof HTMLElement &&
                component.dataset.sectionId &&
                !sectionIds.includes(component.dataset.sectionId)
                ) {
                sectionIds.push(component.dataset.sectionId);
                }
            });

            const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
                },
                body: JSON.stringify({
                items,
                sections: sectionIds.join(',')
                })
            }
            );

            const result = await response.json();

            if (!response.ok || result.status) {
            throw new Error(
                result.description ||
                result.message ||
                'Unable to add box to cart.'
            );
            }

            /*
            * Reproduce the theme's native CartAddEvent.
            *
            * CartAddEvent.eventName === "cart:update"
            */
            document.dispatchEvent(
            new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                resource: {},
                sourceId: 'compose-box',
                data: {
                    source: 'compose-box',
                    itemCount: currentLimit,
                    productId: box.dataset.productId || '',
                    sections: result.sections
                }
                }
            })
            );

            /*
            * Reset the configurator after successful addition.
            */
            resetFlavors();
            updateInterface();

        } catch (error) {
            console.error('Compose box error:', error);

            alert(error.message);
        } finally {
            isSubmitting = false;
            updateInterface();
        }
    });




    const initiallySelected =
      box.querySelector('[data-compose-format].is-selected') ||
      formatButtons[0];

    if (initiallySelected) {
      selectFormat(initiallySelected);
    }
  });
});